import { createSelector } from 'reselect'
import { selectBillingUsage } from './selectBillingUsage'
import { selectCurrentBillingCycle } from './selectCurrentBillingCycle'
import { selectCurrentKbPlan } from './selectCurrentKbPlan'
import { selectCurrentInboxPlan } from './selectCurrentInboxPlan'
import { selectIsBillingDataLoaded } from './selectIsBillingDataLoaded'

export const selectCurrentTotalPerCycle = createSelector(
  selectIsBillingDataLoaded,
  selectCurrentInboxPlan,
  selectCurrentKbPlan,
  selectCurrentBillingCycle,
  selectBillingUsage,
  (loaded, inboxPlan, kbPlan, billingCycle, usage) => {
    if (!loaded) return undefined
    const inboxQuantity =
      inboxPlan.pricingModel === 'flat' ? 1 : usage.inbox.users
    const kbQuantity = kbPlan.pricingModel === 'flat' ? 1 : usage.inbox.kbs
    const inboxPeriodPrice = inboxPlan[`${billingCycle}Price`]
    const kbPeriodPrice = kbPlan[`${billingCycle}Price`]
    if (inboxPeriodPrice === undefined) {
      throw new Error('Invalid inbox price')
    }
    if (kbPeriodPrice === undefined) {
      throw new Error('Invalid kb price')
    }

    const inboxSubTotal = inboxQuantity * inboxPeriodPrice
    const kbSubTotal = kbQuantity * kbPeriodPrice

    return inboxSubTotal + kbSubTotal
  }
)
